import React from 'react';
import { VictoryAxis, VictoryChart, VictoryLine } from 'victory';
import { IngredientChartProps } from './utils/Constants';

export const IngredientChart = (props: IngredientChartProps) => {
  const { xLabels, yLabels, chartData, xTitle, yTitle } = props;
  return (
    <VictoryChart>
      <VictoryAxis label={xTitle} tickValues={xLabels} style={style.x} />
      <VictoryAxis dependentAxis label={yTitle} tickValues={yLabels} style={style.y} />
      <VictoryLine style={style.line} data={chartData}></VictoryLine>
    </VictoryChart>
  );
};

const style = {
  x: {
    grid: { stroke: '#000' },
    axis: { stroke: '#000' },
    axisLabel: { fontSize: 12, padding: 25 },
    tickLabels: { fontSize: 10 },
  },
  y: {
    grid: { stroke: '#000' },
    axis: { stroke: '#000' },
    axisLabel: { fontSize: 12, padding: 35 },
    tickLabels: { fontSize: 10 },
  },
  line: {
    data: { stroke: '#4285F4' },
  },
};
